import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_page_card = _resolveComponent("page-card")!
  const _component_app_page = _resolveComponent("app-page")!

  return (_openBlock(), _createBlock(_component_app_page, null, {
    main: _withCtx(() => [
      _createVNode(_component_page_card, { title: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions, {
            title: "配置详情",
            column: 3,
            border: "",
            class: "content"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configDetailKeyMap, (item, key) => {
                return (_openBlock(), _createBlock(_component_el_descriptions_item, {
                  key: key,
                  label: `${item.label}：`,
                  "label-align": "center"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.formatter ? item.formatter(_ctx.configDetail[key]) : _ctx.configDetail[key]), 1)
                  ]),
                  _: 2
                }, 1032, ["label"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}